export const GET_GRADES = 'GET_GRADES';
export const GRADES_LOAD = 'GRADES_LOAD';
export const GET_GRADES_ERROR = 'GET_GRADES_ERROR';



// WEBPACK FOOTER //
// ./src/state/grades/types.js